import { render } from "./RequestItem.vue?vue&type=template&id=470ebaf5&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"

import "./RequestItem.vue?vue&type=style&index=0&id=470ebaf5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470ebaf5"]])

export default __exports__